import ReactFullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useEffect, useRef } from 'react';
import { CalendarOptions } from '@fullcalendar/core';
import { useCalendarContext } from 'providers/CalendarProvider';
import { useAppContext } from 'providers/AppProvider';
import { INITIALIZE_CALENDAR } from 'reducers/CalendarReducer';

interface FullCalendarProps extends CalendarOptions {}

const FullCalendar = ({ ...rest }: FullCalendarProps) => {
  const calendarRef = useRef<ReactFullCalendar>(null);
  const {
    config: { isRTL }
  } = useAppContext();

  const { view, calendarDispatch } = useCalendarContext();

  useEffect(() => {
    const api = calendarRef.current?.getApi();
    if (api) {
      calendarDispatch({ type: INITIALIZE_CALENDAR, payload: api });
    }
  }, []);

  return (
    <ReactFullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
      initialView={view}
      headerToolbar={false}
      // titleFormat={{ year: 'numeric', month: '2-digit', day: '2-digit' }} // this takes priority over the header
      dayMaxEvents={3}
      stickyHeaderDates={false}
      selectable
      selectMirror
      locale={'pt'}
      direction={isRTL ? 'rtl' : 'ltr'}
      firstDay={1}
      businessHours={[
        {
          daysOfWeek: [1, 2, 3, 4, 5],
          startTime: '08:00',
          endTime: '18:00'
        }
      ]}
      slotLabelFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }}
      slotDuration={'00:30:00'} // each slot is 30 minutes
      slotMinTime={'08:00:00'} // calendar starts at 08:00
      slotMaxTime={'20:00:00'} // calendar ends at 20:00
      eventTimeFormat={{
        hour: '2-digit',
        minute: '2-digit',
        hour12: false // ensures 24h format
      }}
      {...rest}
    />
  );
};

export default FullCalendar;
